import { UIKitIcon } from '../icon';

export const uploadIcon: UIKitIcon = {
  name: 'upload',
  // eslint-disable-next-line max-len
  data: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M27.3687 22.14V26.0467C27.3687 26.392 27.2356 26.7233 26.9987 26.9675C26.7618 27.2117 26.4405 27.3489 26.1055 27.3489H5.89499C5.55998 27.3489 5.2387 27.2117 5.00181 26.9675C4.76492 26.7233 4.63184 26.392 4.63184 26.0467V22.14" stroke="inherit" stroke-miterlimit="10"/><path d="M16.2139 22.5697L16.2139 4.42974" stroke="inherit" stroke-miterlimit="10"/><path d="M9.19099 11.0841L16.2141 4L23.2373 11.0841" stroke="inherit" stroke-miterlimit="10"/></svg>',
};
